export const MESSAGE_SYSTEM_TYPE = [
    'healthCheck',
    'notification',
    'channelSubscriptionRequest',
    'channelUnsubscriptionRequest',
    'channelSubscriptionResponse',
    'channelUnsubscriptionResponse',
    'errorMessage',
    'ready',
];
